import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
} from 'react-accessible-accordion';
import {
  StyledDisclaimerBullets,
  StyledResultsDescription,
} from './resultsStyles';
import 'react-accessible-accordion/dist/minimal-example.css';
import FAQuestion from '../landing/FAQuestion';
import Title from './Title';


const QuestionSection = ({ questions, styles }) => (
  <Accordion
    accordion={false}
    style={{
      width: '90%', marginBottom: '10px', maxWidth: '750px', ...styles,
    }}
  >
    {
     questions.map((question, idx) => (
       <FAQuestion
         question={{
           question: question.title,
           answer:
  <Fragment>
    {
                 question.answers.map((answer, idx) => (
                   <Fragment key={answer.bullets.length * idx}>
                     <StyledResultsDescription>
                       { answer.subTitle && <Title level={6}>{answer.subTitle}</Title> }
                       {
                       answer.bullets.map((bullet, idx) => (
                         <StyledDisclaimerBullets key={bullet.length * idx}>
                           {bullet}
                         </StyledDisclaimerBullets>
                       ))
                     }
                     </StyledResultsDescription>
                   </Fragment>
                 ))
               }
  </Fragment>,
         }}
         borderBottom={question.borderBottom}
       />
     ))
        }
  </Accordion>
);

QuestionSection.propTypes = {
  questions: PropTypes.object,
  styles: PropTypes.object,
};

QuestionSection.defaultProps = {
  questions: {},
  styles: {},
};

export default QuestionSection;
